export default __webpack_public_path__ + "static/media/screenshot_project_show.0df1fc8f.png";